import { render } from "./ChooseParty.vue?vue&type=template&id=0f06e42f&scoped=true&ts=true"
import script from "./ChooseParty.vue?vue&type=script&lang=ts"
export * from "./ChooseParty.vue?vue&type=script&lang=ts"

import "./ChooseParty.vue?vue&type=style&index=0&id=0f06e42f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f06e42f"]])

export default __exports__